import React from 'react';
import '../Button.scss';

// Use for buttons that need to be controlled by
// styles settings in the CMS, NOT by primaryColor

const ButtonHover = ({
  hovering,
  onEnter,
  onLeave,
  children,
  handleClick,
  normal,
  hover,
  active,
  isMobile,
  ...rest
}) => {
  const activeStyle = {
    color: hover.text,
    backgroundColor: hover.background,
  };
  const defaultStyle = {
    color: normal.text,
    backgroundColor: normal.background,
  };

  const btnStyles = hovering || active ? activeStyle : defaultStyle;

  return (
    <button
      style={btnStyles}
      onClick={handleClick}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      aria-expanded={active}
      {...rest}
    >
      {children}
    </button>
  );
};

export default ButtonHover;
